import {Component, h, Host, Prop, Watch} from "@stencil/core";
import "@bun-ui/layout";

@Component({
    tag: "lb-errorview",
    shadow: true,
})
export class ErrorView {

    @Prop() error: any;
    @Prop() i18n: any;
    @Prop({reflect: true}) language: string = "de";

    @Watch('error')
    onErrorChange(error) {
      if(error){
        this.processErrorResponse(error);
      }
    }

    componentDidLoad() {
      this.processErrorResponse(this.error);
    }

    processErrorResponse(error) {
      if(!error){
        return;
      }

      let errorProcessed;
      if (error["error"] && error["error"].length > 255) {
          errorProcessed = error;
          if (error["error"].indexOf("Eingabe") !== -1) {
              errorProcessed["error"] = error["error"].split("Eingabe: ")[0];
          } else {
              errorProcessed["error"] = error["error"].substring(0, 200);
          }
      }
      this.error = errorProcessed || error;
    }

    render() {
        return (
            <Host>
              <c-header type="h2" role="heading">
                { this.i18n?.meta?.[this.language]?.error?.errorHeadline }
              </c-header>
              <c-text>{ this.i18n?.meta?.[this.language]?.error?.errorText }</c-text>
              <c-dl>
                <dt>{ this.i18n?.meta?.[this.language]?.error?.errorMsgLabel }</dt>
                <dd>{this.error?.error || "-"}</dd>
                <dt>{ this.i18n?.meta?.[this.language]?.error?.errorTraceIdLabel }</dt>
                <dd>{this.error?.traceId || "-"}</dd>
                <dt>{ this.i18n?.meta?.[this.language]?.error?.errorTimestampLabel }</dt>
                <dd>{this.error?.timestamp || "-"}</dd>
              </c-dl>
            </Host>
        );
    }
}